'use strict'

export default buffer => String
  .fromCharCode
  .apply(null, new Uint8Array(buffer))
